export default __webpack_public_path__ + "static/media/relax-mono.fa1e52a4.svg";